import axios from 'axios';
import url from './base-url';
import sessions from '../sessions';
const api = axios.create({
    baseURL: url
});

export const createAccount = payload => api.post('/register',payload);
export const getUser = () => sessions.getSession("user");
export const signIn = payload => api.post('/signIn',payload); 
export const resendEmail = email => api.get(`/resend/${email}`);
export const confirmation = verificationToken => api.post("/confirmation",{verificationToken:verificationToken});

export async function changePassword(newPassword, recoveryCode) {
  try {
    // Send request
    //console.log(newPassword, recoveryCode);
    const sendData = await api.put("/change-password", {recoveryCode:recoveryCode, newPassword: newPassword})
    //console.log('sendData', sendData)  
    if(sendData.data.success === true) {
      return {
        isOk: true,
        message: sendData.data.message
      };
    } else {
      return {
        isOk: false,
        message: sendData.data.message
      };
    }
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  };
}

export async function resetPassword(email) {
  try {
    // Send request
    console.log(email);
    await api.post(`/reset-password`, { email: email })
    return {
      isOk: true
    };        
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password. Please check your email and try again!"
    };
  }
}

const apis = {
    signIn,
    createAccount,   
    getUser,
    resendEmail,
    confirmation
}
export default apis;